import React from "react"
import PropTypes from "prop-types"
import {Box} from "@mui/material"
import FormSectionAccordion from "src/v2/components/FormSectionAccordion"
import theme from "src/v2/theme/theme"
import {ReactComponent as CheckIcon} from "src/v2/assets/icons/check-icon.svg"
import { renderGrid } from "src/v2/components/FieldRenderer"
import {fatorArredondamentoFields} from "./constants"

const FatorArredondamentoSection = ({
    state,
    setSectionField,
    actions,
    defaultOpen = false,
    syncToken = 0,
    autoCompleteController = {},
}) => {
    return (
        <Box sx={{mt: 0}}>
            <FormSectionAccordion
                title="Fator e Arredondamento"
                icon={<CheckIcon style={{color: theme.palette.icon.main, width: 20, height: 20}} />}
                actions={actions}
                defaultOpen={defaultOpen}
                syncToken={syncToken}
                disableBorder={true}
            >
                {renderGrid(
                    fatorArredondamentoFields,
                    state,
                    (key) => (value) => setSectionField("fatorArredondamento", key, value),
                    undefined,
                    {spacing: 2},
                    (key, value) => setSectionField("fatorArredondamento", key, value),
                    autoCompleteController
                )}

            </FormSectionAccordion>
        </Box>
    )
}

FatorArredondamentoSection.propTypes = {
    state: PropTypes.object.isRequired,
    setSectionField: PropTypes.func.isRequired,
    actions: PropTypes.node,
    defaultOpen: PropTypes.bool,
    syncToken: PropTypes.number,
    autoCompleteController: PropTypes.object,
}

export default FatorArredondamentoSection